/**
 * Document api script class
 *
 * @package    Api
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

export default class DocumentApi {
    /**
     * Send request for load document
     *
     * @param {Object} data - Document data
     */
    static loadDocument (data) {
        return (axios) => axios.get('/ribyt/rsvp/hellosign', {
            params: data,
        });
    }

    /**
     * Send request for update document
     *
     * @param {String} inviteHash - Invite hash
     * @param {Object} data - Document data
     */
    static updateDocument (inviteHash, data) {
        return (axios) => axios.put(`/ribyt/rsvp/hellosign/${ inviteHash }`, data);
    }
}
